"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Catalog_module_scss_1 = __importDefault(require("./Catalog.module.scss"));
var BreadCrumpPage_1 = require("../../breadCrumpPage/BreadCrumpPage");
var Loader_1 = require("../../loader/Loader");
var react_2 = require("swiper/react");
var modules_1 = require("swiper/modules");
var carCatologList_1 = __importDefault(require("../../carCatologList/carCatologList"));
var carCatologIcons_1 = require("../../carCatologIcons/carCatologIcons");
var icons_1 = require("@ant-design/icons");
var selectors_1 = require("../../../redux/selectors");
var react_redux_1 = require("react-redux");
var Catalog = function () {
    var _a = (0, react_1.useState)(null), carsCatalog = _a[0], setCarsCatalog = _a[1];
    var _b = (0, react_1.useState)(null), catalogModels = _b[0], setCatalogModels = _b[1];
    var _c = (0, react_1.useState)(false), isLoadingCatalog = _c[0], setLoadingCatalog = _c[1];
    var _d = (0, react_1.useState)(false), isLoadingAllCatalog = _d[0], setLoadingAllCatalog = _d[1];
    var _e = (0, react_1.useState)(false), isDesktop = _e[0], setIsDesktop = _e[1];
    var swiperCardRef = (0, react_1.useRef)(null);
    var _f = react_1.default.useState(false), visibleMore = _f[0], setVisibleMore = _f[1];
    var isSmall = (0, react_redux_1.useSelector)(selectors_1.mediaQuerySelector).isSmall;
    var visibleItems = (0, react_1.useMemo)(function () {
        return visibleMore ? carsCatalog : carsCatalog === null || carsCatalog === void 0 ? void 0 : carsCatalog.slice(0, isSmall ? 18 : 24);
    }, [isSmall, carsCatalog, visibleMore]);
    var handleMoreBtn = function () {
        setVisibleMore(function (prev) { return !prev; });
    };
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoadingCatalog(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalogs/all_catalog"))];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _a.sent();
                        setCarsCatalog(result);
                        setLoadingCatalog(false);
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var fetchAllCatalog = function () { return __awaiter(void 0, void 0, void 0, function () {
            var responseAllCatalog, resultAllCatalog, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoadingAllCatalog(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalogs"))];
                    case 2:
                        responseAllCatalog = _a.sent();
                        return [4 /*yield*/, responseAllCatalog.json()];
                    case 3:
                        resultAllCatalog = _a.sent();
                        setCatalogModels(resultAllCatalog);
                        setLoadingAllCatalog(false);
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
        fetchAllCatalog();
    }, []);
    (0, react_1.useEffect)(function () {
        var handleResize = function () {
            setIsDesktop(window.innerWidth > 1160);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    var filterModels = function (brand) {
        if (catalogModels) {
            return catalogModels.filter(function (car) { return car.brand === brand; });
        }
    };
    var handleNext = (0, react_1.useCallback)(function () {
        var _a;
        (_a = swiperCardRef.current) === null || _a === void 0 ? void 0 : _a.swiper.slideNext();
    }, []);
    var handlePrev = (0, react_1.useCallback)(function () {
        var _a;
        (_a = swiperCardRef.current) === null || _a === void 0 ? void 0 : _a.swiper.slidePrev();
    }, []);
    return (react_1.default.createElement("div", { className: Catalog_module_scss_1.default.container },
        react_1.default.createElement("div", { className: Catalog_module_scss_1.default.page },
            react_1.default.createElement(BreadCrumpPage_1.BreadCrumpPage, { links: [
                    { name: 'Главная', url: '/' },
                    { name: 'Каталог', url: '/catalog' },
                ] }),
            react_1.default.createElement("div", { className: Catalog_module_scss_1.default.catalog },
                isLoadingCatalog ? (react_1.default.createElement(Loader_1.Loader, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                    isDesktop ? (react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: Catalog_module_scss_1.default.top__brands_container }, visibleItems === null || visibleItems === void 0 ? void 0 : visibleItems.map(function (car) {
                            return (react_1.default.createElement(carCatologIcons_1.CarCatologIcons, __assign({ key: "".concat(car.brand, "_").concat(car.models_count) }, car)));
                        })),
                        react_1.default.createElement("button", { className: Catalog_module_scss_1.default.in_stock__btn_more, onClick: handleMoreBtn, type: "button" }, visibleMore ? (react_1.default.createElement(react_1.default.Fragment, null,
                            "\u0421\u043A\u0440\u044B\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043C\u0430\u0440\u043A\u0438 ",
                            ' ',
                            react_1.default.createElement(icons_1.ArrowUpOutlined, { className: Catalog_module_scss_1.default.in_stock__arrow_icon }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                            "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u043C\u0430\u0440\u043E\u043A ",
                            ' ',
                            react_1.default.createElement(icons_1.ArrowDownOutlined, { className: Catalog_module_scss_1.default.in_stock__arrow_icon })))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_2.Swiper, { ref: swiperCardRef, touchEventsTarget: "container", breakpoints: {
                                300: {
                                    slidesPerView: 2,
                                    grid: {
                                        rows: 3,
                                    },
                                    spaceBetween: 5,
                                },
                                512: {
                                    slidesPerView: 3,
                                    grid: {
                                        rows: 3,
                                    },
                                    spaceBetween: 10,
                                },
                                750: {
                                    slidesPerView: 4,
                                    grid: {
                                        rows: 3,
                                    },
                                    spaceBetween: 10,
                                },
                                930: {
                                    slidesPerView: 5,
                                    grid: {
                                        rows: 3,
                                    },
                                    spaceBetween: 10,
                                },
                                1160: {
                                    slidesPerView: 6,
                                    grid: {
                                        rows: 3,
                                    },
                                    spaceBetween: 10,
                                },
                            }, mousewheel: true, pagination: {
                                dynamicBullets: true,
                                clickable: true,
                            }, modules: [modules_1.Pagination, modules_1.Grid, modules_1.Mousewheel], className: Catalog_module_scss_1.default.top__brands_container, wrapperClass: Catalog_module_scss_1.default.swiper__wrapper }, carsCatalog === null || carsCatalog === void 0 ? void 0 :
                            carsCatalog.map(function (car) {
                                return (react_1.default.createElement(react_2.SwiperSlide, { key: "".concat(car.brand, "_").concat(car.models_count) },
                                    react_1.default.createElement(carCatologIcons_1.CarCatologIcons, __assign({}, car))));
                            }),
                            react_1.default.createElement("div", { className: Catalog_module_scss_1.default.box_vector },
                                react_1.default.createElement("button", { className: Catalog_module_scss_1.default.box_vector__vector_left, onClick: handlePrev },
                                    react_1.default.createElement(icons_1.LeftOutlined, null)),
                                react_1.default.createElement("button", { className: Catalog_module_scss_1.default.box_vector__vector_right, onClick: handleNext },
                                    react_1.default.createElement(icons_1.RightOutlined, null)))))),
                    react_1.default.createElement("h2", { className: Catalog_module_scss_1.default.top__brands_title }, "C\u043F\u0438\u0441\u043E\u043A \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439"))),
                isLoadingAllCatalog ? (react_1.default.createElement(Loader_1.Loader, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: Catalog_module_scss_1.default.car_list_wrapper }, carsCatalog === null || carsCatalog === void 0 ? void 0 : carsCatalog.map(function (car, index) {
                        return (react_1.default.createElement(carCatologList_1.default, { key: "".concat(car.brand, "_").concat(index), carData: filterModels(car.brand), brand: car.brand }));
                    }))))))));
};
exports.default = Catalog;
